import React from "react"

/**
 * Paso 4 — Información Clínica
 * Diagnóstico CIE-10, procedimiento CIE-9, imagen y hemoderivados
 */
const StepClinica = ({
    // Diagnóstico
    diagnostico, diagnosticoSeleccionado,
    onChangeDiagnostico, onFocusDiagnostico, onBlurDiagnostico,
    seMuestra, handleCancelarClick, resultList, handleDiagnosticoChange,
    MAX,
    // Procedimiento
    procedimientoHadError,
    procedimiento, procedimientoSeleccionado,
    onChangeProcedimiento, onFocusProcedimiento, onBlurProcedimiento,
    seMuestraProdecimiento, handleCancelarProcedimientoClick,
    resultProcedimientoList, handleProcedimientoChange,
    // Imagen
    isRayosX, onCheckRayosX,
    isArcoC, onCheckArcoC,
    isNoRequiereImagen, onCheckNorequiereImagen,
    // Hemoderivados
    hemoderivadosHadError,
    hadHemoderivados, onCheckHemoderivados,
    hemoderivados, onChangeHemoderivados,
    // Material o Equipo especial
    hadMaterialEquipoEspecial, onCheckMaterialEquipoEspecial,
    materialEquipoEspecial, onChangeMaterialEquipoEspecial,
}) => (
    <div className="rq-panel">

        <div className="rq-info-tip">
            💡 Proporcione al menos 3 caracteres para buscar en el catálogo
        </div>

        {/* Diagnóstico CIE-10 */}
        {/* <div className="rq-field" id="contenedorDiagnostico">
            <label className="rq-label">Diagnóstico CIE-10</label>
            {diagnosticoSeleccionado && (
                <span className="rq-selected-badge">{diagnosticoSeleccionado}</span>
            )}
            <div className="rq-content">
                <div className="rq-autocomplete">
                    <textarea
                        id="diagnostico"
                        className="rq-textarea"
                        value={diagnostico}
                        onChange={onChangeDiagnostico}
                        onFocus={onFocusDiagnostico}
                        onBlur={onBlurDiagnostico}
                        rows="2"
                        placeholder="Buscar diagnóstico..."
                        maxLength={MAX.diagnostico}
                    />
                    {seMuestra && (
                        <span className="rq-clear" onClick={handleCancelarClick()}>✕</span>
                    )}
                </div>
                {resultList.length > 0 && (
                    <ul className="rq-suggestions">
                        {resultList.map(res => (
                            <li key={res.id} onMouseDown={() => handleDiagnosticoChange(res.NOMBRE)}>
                                {res.NOMBRE}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div> */}

        {/* Procedimiento CIE-9 */}
        <div className={procedimientoHadError ? "rq-field rq-field--error" : "rq-field"} id="contenedorProcedimiento">
            <label className="rq-label">Procedimiento CIE-9<span className="rq-required">*</span></label>
            {procedimientoSeleccionado && (
                <span className="rq-selected-badge">{procedimientoSeleccionado}</span>
            )}
            <div className="rq-content">
                <div className="rq-autocomplete">
                    <textarea
                        id="procedimiento"
                        className="rq-textarea"
                        value={procedimiento}
                        onChange={onChangeProcedimiento}
                        onFocus={onFocusProcedimiento}
                        onBlur={onBlurProcedimiento}
                        rows="2"
                        placeholder="Buscar procedimiento..."
                        maxLength={MAX.procedimiento}
                    />
                    {seMuestraProdecimiento && (
                        <span className="rq-clear" onClick={handleCancelarProcedimientoClick()}>✕</span>
                    )}
                </div>
                {resultProcedimientoList.length > 0 && (
                    <ul className="rq-suggestions">
                        {resultProcedimientoList.map(res => (
                            <li key={res.CATALOG_KEY} onMouseDown={() => handleProcedimientoChange(res.PRO_NOMBRE)}>
                                <span className="rq-sug-code">{res.CATALOG_KEY}</span>
                                <span className="rq-sug-name">{res.PRO_NOMBRE}</span>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>

        {/* Imagen — oculto a petición: no se elimina la lógica, solo se deja
            de mostrar. isRayosX/isArcoC/isNoRequiereImagen mantienen sus
            valores por defecto (false/false/false) y se siguen enviando así. */}
        {/* <div className="rq-field" id="contenedorImagenEstudios">
            <label className="rq-label">¿Requiere servicios de imagen?</label>
            <div className="rq-content rq-check-group">
                <label className="rq-checkbox-item">
                    <input type="checkbox" checked={isRayosX} onChange={onCheckRayosX}/> Rayos X
                </label>
                <label className="rq-checkbox-item">
                    <input type="checkbox" checked={isArcoC} onChange={onCheckArcoC}/> Arco en C
                </label>
                <label className="rq-checkbox-item">
                    <input type="checkbox" checked={isNoRequiereImagen} onChange={onCheckNorequiereImagen}/> No se requiere
                </label>
            </div>
        </div> */}

        {/* Hemoderivados — oculto a petición: no se elimina la lógica, solo
            se deja de mostrar. hadHemoderivados/hemoderivados mantienen sus
            valores por defecto (false/'') y se siguen enviando así. */}
        {/* <div className={hemoderivadosHadError ? "rq-field rq-field--error" : "rq-field"} id="contenedorHemoderivados">
            <label className="rq-label">Requerimiento de sangre y/o hemoderivados</label>
            <div className="rq-content rq-check-group">
                <label className="rq-checkbox-item">
                    <input type="checkbox" checked={hadHemoderivados} onChange={onCheckHemoderivados}/> Sí se requiere
                </label>
                <label className="rq-checkbox-item">
                    <input type="checkbox" checked={!hadHemoderivados} onChange={onCheckHemoderivados}/> No se requiere
                </label>
            </div>
            {hadHemoderivados && (
                <div className="rq-content">
                    <textarea
                        className="rq-textarea"
                        value={hemoderivados}
                        onChange={onChangeHemoderivados}
                        rows="3"
                        placeholder="Especifique el tipo y cantidad..."
                        maxLength={MAX.hemoderivados}
                    />
                </div>
            )}
        </div> */}

        {/* Material o Equipo especial */}
        <div className="rq-field" id="contenedorMaterialEquipoEspecial">
            <label className="rq-label">
                <input type="checkbox" checked={hadMaterialEquipoEspecial} onChange={onCheckMaterialEquipoEspecial} style={{marginRight:"8px"}}/>
                ¿Requiere de algún Material o Equipo especial?
            </label>
            {hadMaterialEquipoEspecial && (
                <div className="rq-content">
                    <textarea
                        className="rq-textarea"
                        value={materialEquipoEspecial}
                        onChange={onChangeMaterialEquipoEspecial}
                        rows="3"
                        placeholder="Especifique el material o equipo especial requerido..."
                        maxLength={MAX.materialEquipoEspecial}
                    />
                </div>
            )}
        </div>

    </div>
)

export default StepClinica